// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".actions-panel__option[data-v-06868cde]{display:flex;flex-direction:column;align-items:center;border-bottom:1px solid #e0e0e0;padding:5px 0}.actions-panel__active[data-v-06868cde]{border-left:2px solid #24a148}.actions-panel div[data-v-06868cde]{font-size:12px;line-height:16px!important;letter-spacing:.32px}", ""]);
// Exports
module.exports = exports;
